<template>
    <div class="replyMain">
        <p class="introduce">说明：提交后请等待教师评阅审核，教师完成评阅或审核后即可查看评阅或审核记录</p>
        <el-form ref="form" :model="form" :rules="rules" label-width="100px" class="replyform">
            <el-form-item :label="$getShowName() + '题名'" prop="thesisTitle">
                <el-input v-model="form.thesisTitle" :disabled="disabledset"></el-input>
            </el-form-item>
            <el-form-item label="选题描述" prop="thesisDescription">
                <el-input type="textarea" v-model="form.thesisDescription" :disabled="disabledset"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="save" :disabled="disabledset">提交</el-button>
                <span style="color: red;">{{ endMsg }}</span>
            </el-form-item>
        </el-form>
        <el-row>

            <p>审核记录</p>
            <el-table :data="recordData" border style="width: 100%">
                <el-table-column align="center" prop="submitTime" label="提交时间">
                </el-table-column>
                <el-table-column align="center" prop="choiceThesisTitle" :label="$getShowName() + '题名'">
                </el-table-column>
                <el-table-column align="center" prop="choiceThesisTitleDescription" label="选题描述">
                </el-table-column>
                <el-table-column align="center" prop="approveTeacherName" label="指导老师">
                </el-table-column>
                <el-table-column align="center" prop="approveStatusText" label="审核状态">
                </el-table-column>
                <el-table-column align="center" prop="approveOpinion" label="审核意见">
                </el-table-column>
                <el-table-column align="center" prop="approveTime" label="审核时间">
                </el-table-column>
            </el-table>
        </el-row>
    </div>
</template>
<script>
export default {
    name: "reply",
    data() {
        return {
            rules: {
                thesisTitle: [
                    {
                        required: true,
                        message: "请输入论文题目",
                        trigger: "blur",
                    }
                ],
                thesisDescription: [
                    {
                        required: true,
                        message: "请输入选题描述",
                        trigger: "blur",
                    },
                ],

            },
            form: {
                thesisRecordId: '',
                thesisTitle: '',
                thesisDescription: ''
            },
            thesisRecord: {}, //提交内容
            recordData: [], //审核记录
            state: 0, //0  1  2  3未提交  未审批 驳回修改   完成
            disabledset: false,
            endMsg: '', //超过截止时间msg
            selectionDead: false, //选题是否到截止时间
        }
    },
    created() {
    },
    mounted() {
        this.recordDataset();
        this.deadlineFunction();
    },
    methods: {
        deadlineFunction() {
            let param = {}
            this.$store.dispatch("thesis/getDeadline", param).then((ret) => {
                if (ret.code == 0) {
                    this.selectionDead = ret.data.selectionDead;
                    if (this.selectionDead == true) {
                        this.disabledset = true
                        this.endMsg = '已超过截止时间，无法提交'
                    }
                } else {
                    this.$message.error(ret.msg);
                }
            })
        },
        recordDataset(thesisRecordId) {
            let param = {
                thesisRecordId: thesisRecordId
            }
            this.$store.dispatch("thesis/getThesisCheckDetailByParam", param).then((ret) => {
                if (ret.code == 0) {
                    this.thesisRecord = ret.data.thesisRecord
                    this.recordData = ret.data.thesisApproveList.filter((item) => {
                        return item.thesisStatus == 1
                    })  //审核记录
                    let thesisStatus = ret.data.thesisRecord.thesisStatus
                    if (thesisStatus > 1) {
                        this.state = 3
                        this.disabledset = true
                        this.form.thesisRecordId = this.thesisRecord.id
                        this.form.thesisTitle = this.thesisRecord.choiceThesisTitle
                        this.form.thesisDescription = this.thesisRecord.choiceThesisTitleDescription
                    } else if (thesisStatus == 1) {
                        /* 未驳回 */
                        if (this.thesisRecord.isReject == 0) {
                            this.state = 1
                            this.disabledset = true
                        } else { //驳回
                            this.state = 2
                            this.disabledset = false
                        }
                        /* 内容回显 */
                        this.form.thesisRecordId = this.thesisRecord.id
                        this.form.thesisTitle = this.thesisRecord.choiceThesisTitle
                        this.form.thesisDescription = this.thesisRecord.choiceThesisTitleDescription
                    }

                } else {
                    this.$message.error(ret.msg);
                }
            }).catch((err) => {

            });
        },
        save() {
            if (this.state == 2) { //编辑
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        let param = {
                            thesisRecordId: this.form.thesisRecordId,
                            thesisTitle: this.form.thesisTitle,
                            thesisDescription: this.form.thesisDescription
                        }
                        this.$store.dispatch("thesis/editChoice", param).then((ret) => {
                            if (ret.code == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '选题编辑成功',
                                    type: 'success'

                                });
                                this.recordDataset()
                            } else {
                                this.$message.error(ret.msg);
                            }
                        }).catch((err) => {
                        });
                    } else {

                        return false;
                    }
                });
            } else { //新增
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        let param = {
                            thesisTitle: this.form.thesisTitle,
                            thesisDescription: this.form.thesisDescription
                        }
                        this.$store.dispatch("thesis/commitChoice", param).then((ret) => {
                            if (ret.code == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '选题提交成功',
                                    type: 'success'

                                });
                                this.recordDataset()
                            } else {
                                this.$message.error(ret.msg);
                            }
                        }).catch((err) => {
                        });
                    } else {

                        return false;
                    }
                });

            }

        },

    }

}
</script>
<style lang="less" scoped>
.replyMain {
    padding: 15px;

    .introduce {
        color: red;
        margin-bottom: 50px;
    }

    .replyform {
        width: 868px;
        margin: 0 auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/transactionPaper/writeGroup/topicchoice.vue